import styled from 'styled-components'

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: grid;
  place-items: center;
  padding: 0;

  .circle {
    --size: ${({ size }) => `${size}px`};
    display: grid;
    place-items: center;
    width: var(--size);
    height: var(--size);
    border-radius: 100vmax;
    color: ${({ theme, selected }) => (selected ? theme.text_active_green : '#bbb')};
    border: 1px solid;
  }
`
